var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.303083,
    width: 60,
    height: 60,
    rx: 11,
    fill: "#61B7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 23.625V13H16.875C15.7812 13 15 13.8594 15 14.875V51.125C15 52.2188 15.7812 53 16.875 53H43.125C44.1406 53 45 52.2188 45 51.125V25.5H34.375C33.2812 25.5 32.5 24.7188 32.5 23.625ZM37.1875 31.9844L32.5 39.25L37.1875 46.5938C37.5781 47.2188 37.1094 48 36.4062 48H33.6719C33.2812 48 32.9688 47.8438 32.8125 47.5312C31.25 44.7188 30 42.1406 30 42.1406C29.4531 43.3125 29.2188 43.7031 27.1094 47.5312C26.9531 47.8438 26.6406 48.0781 26.25 48.0781H23.5938C22.8125 48.0781 22.3438 47.2188 22.7344 46.5938L27.5 39.3281L22.7344 31.9844C22.3438 31.3594 22.8125 30.5781 23.5938 30.5781H26.25C26.6406 30.5781 26.9531 30.7344 27.1094 31.0469C29.1406 34.875 28.6719 33.625 30 36.3594C30 36.3594 30.4688 35.5 32.8125 31.0469C32.9688 30.7344 33.2812 30.5781 33.6719 30.5781H36.4062C37.1094 30.5 37.5781 31.3594 37.1875 31.9844ZM45 22.5312C45 22.0625 44.7656 21.5938 44.4531 21.2031L36.7969 13.5469C36.4062 13.2344 35.9375 13 35.4688 13H35V23H45V22.5312Z",
    fill: "#6CB1EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExcel);
export default __webpack_public_path__ + "static/media/fileExcel.8047e0d019e738284e169bfc6e0e9585.svg";
export { ForwardRef as ReactComponent };